/**
 * Webhooks: Ereignisse für Kunden mit eigener Warenwirtschaft/ERP. Signatur wie üblich (Stripe-Stil):
 *   X-Logiful-Signature: t=<Unix-Sekunden>,v1=<hex HMAC-SHA256(geheimnis, "<t>.<body>")>
 * Empfänger prüfen Signatur und Zeitstempel (z. B. max. 5 Minuten alt) und antworten mit 2xx.
 */
export const WEBHOOK_EVENTS = {
  "order.created": "Auftrag eingegangen",
  "order.on_hold": "Auftrag zurückgehalten (mit Grund)",
  "order.submitted": "Auftrag an das Lager übergeben",
  "order.shipped": "Auftrag versendet (mit Trackingnummern)",
  "order.cancelled": "Auftrag storniert oder abgelehnt",
  "inbound.received": "Wareneingang eingebucht (teilweise oder vollständig)",
  "return.processed": "Retoure im Lager geprüft (Zustand je Artikel)",
  "order.delayed": "Auftrag wartet auf Ware (Lieferverzögerung)",
  "shipment.out_for_delivery": "Paket in Zustellung (Track & Trace)",
  "shipment.pickup_ready": "Paket liegt zur Abholung bereit (Track & Trace)",
  "shipment.delivered": "Paket zugestellt (Track & Trace)",
  "shipment.exception": "Zustellproblem oder Rücksendung an den Absender (Track & Trace)",
} as const;
export type WebhookEvent = keyof typeof WEBHOOK_EVENTS;
export const WEBHOOK_EVENT_KEYS = Object.keys(WEBHOOK_EVENTS) as WebhookEvent[];

/** Historien-Aktion → Ereignis (Webhooks werden aus der lückenlosen Historie abgeleitet) */
export const AUDIT_TO_WEBHOOK: Record<string, WebhookEvent> = {
  "order.received": "order.created",
  "order.on_hold": "order.on_hold",
  "order.submitted": "order.submitted",
  "order.shipped": "order.shipped",
  "order.cancelled": "order.cancelled",
  "order.rejected": "order.cancelled",
  "inbound.received": "inbound.received",
  "inbound.partially_received": "inbound.received",
  // Track & Trace: je Paket bei Statuswechsel (Historie „delivery.<status>“)
  "delivery.out_for_delivery": "shipment.out_for_delivery",
  "delivery.pickup_ready": "shipment.pickup_ready",
  "delivery.delivered": "shipment.delivered",
  "delivery.exception": "shipment.exception",
  "delivery.returned": "shipment.exception",
};

/** Wiederholungen nach Fehlschlag: 1 Min., 5 Min., 30 Min., 2 Std., 6 Std., 12 Std., 24 Std. – danach aufgegeben */
export const WEBHOOK_RETRY_MINUTES = [1, 5, 30, 120, 360, 720, 1440];
export const WEBHOOK_MAX_ATTEMPTS = WEBHOOK_RETRY_MINUTES.length + 1;
/** so viele Fehlschläge in Folge → Ziel wird pausiert (Kunde wird informiert) */
export const WEBHOOK_DISABLE_AFTER = 50;
